import { Box } from '@mui/material'
import Slider from 'react-slick'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Suisse from '../../../frontend-lib/typhograpy/Suisse'
import { WeKeepAnEyeCard } from './WeKeepAnEyeCard'

export function WeKeepAnEyeOutForSection({
  carouselSettings,
  alertsInformation,
}) {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        pt: 5,
        px: { xs: 4, sm: 4, md: 8, lg: 15, xl: 15 },
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        backgroundColor: 'purple.2',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <Box
        sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}
      >
        <Suisse color="white" size={14}>
          {t('weKeepAnEyeOutFor')}
        </Suisse>
      </Box>
      <Box sx={{ py: 6, width: '100%', height: '216px' }}>
        <Slider {...carouselSettings}>
          {alertsInformation.map((alert) => (
            <Box key={alert.id}>
              <WeKeepAnEyeCard title={alert.title} icon={alert.icon} />
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  )
}
